// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Label from "../../primitives/Label.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import * as TextLink from "../navigation/TextLink.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as TooltipIcon from "../overlays/TooltipIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let make = React.memo(props => {
  let newrecord = {
    ...{
      0: {
        className: "font-xhhohpu lineHeight-xwn7fz2 paddingTop-x1iorvi4 color-x1re7szb",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Field.res.js:17; wino-gc:src/resources/layout-and-structure/Field.res.js:25"
      },
      1: {
        className: "font-xhhohpu lineHeight-xwn7fz2 paddingTop-x1iorvi4 color-x1qqs05d",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Field.res.js:17; wino-gc:src/resources/layout-and-structure/Field.res.js:22"
      }
    }[!!(props.variation === "information") << 0]
  };
  return JsxRuntime.jsx("span", (newrecord.children = props.children, newrecord));
});
function makeLabel(label, required) {
  if (label === "") {
    if (required) {
      return I18n.t("Required field") + " *";
    } else if (required) {
      return label + " *";
    } else {
      return label;
    }
  } else if (required) {
    return label + " *";
  } else {
    return label;
  }
}
let Action = {};
let make$1 = React.forwardRef((props, ref) => {
  let __required = props.required;
  let action = props.action;
  let errorMessage = props.errorMessage;
  let tooltip = props.tooltip;
  let labelAriaProps = props.labelAriaProps;
  let label = props.label;
  let required = __required !== undefined ? __required : false;
  let ref$1 = ref == null ? undefined : Primitive_option.some(ref);
  let labelRef = React.useRef(null);
  let newrecord = {
    ...{
      className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Field.res.js:36"
    }
  };
  newrecord.ref = Stdlib_Option.map(ref$1, prim => prim);
  let tmp;
  if (label !== undefined) {
    if (action !== undefined) {
      let handler = action.handler;
      let text = action.text;
      let tmp$1;
      switch (handler.TAG) {
        case "Callback":
          let action$1 = handler._0;
          tmp$1 = JsxRuntime.jsx(Touchable.make, {
            children: JsxRuntime.jsx(TextStyle.make, {
              children: text,
              size: "xsmall",
              underlined: true
            }),
            excludeFromTabOrder: true,
            style: {
              marginBottom: "3px"
            },
            onPress: param => action$1()
          });
          break;
        case "OpenLink":
          tmp$1 = JsxRuntime.jsx(TextLink.make, {
            text: text,
            to: handler._0
          });
          break;
        case "OpenLinkNewTab":
          tmp$1 = JsxRuntime.jsx(TextLink.make, {
            text: text,
            to: handler._0,
            openNewTab: true
          });
          break;
      }
      tmp = JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(Label.make, {
          text: makeLabel(label, required),
          ariaProps: labelAriaProps
        }), tooltip !== undefined ? JsxRuntime.jsx(TooltipIcon.make, {
          children: tooltip,
          variation: "info",
          placement: "bottom start",
          altTriggerRef: labelRef,
          crossOffset: -1
        }) : null, tmp$1],
        align: "spaceBetween"
      });
    } else {
      let newrecord$1 = {
        ...{
          style: {
            width: "fit-content"
          }
        }
      };
      tmp = JsxRuntime.jsx("div", (newrecord$1.ref = Primitive_option.some(labelRef), newrecord$1.children = JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(Label.make, {
          text: makeLabel(label, required),
          ariaProps: labelAriaProps
        }), tooltip !== undefined ? JsxRuntime.jsx(TooltipIcon.make, {
          children: tooltip,
          variation: "info",
          placement: "bottom start",
          altTriggerRef: labelRef,
          crossOffset: -1
        }) : null],
        space: "xsmall",
        alignY: "top"
      }), newrecord$1));
    }
  } else {
    tmp = null;
  }
  let tmp$2;
  tmp$2 = errorMessage !== undefined && errorMessage !== "" ? JsxRuntime.jsx(make, {
    children: errorMessage,
    variation: "error"
  }) : null;
  newrecord.children = [tmp, props.children, tmp$2];
  return JsxRuntime.jsxs("div", newrecord);
});
let make$2 = React.memo(make$1);
export { makeLabel, Action, make$2 as make };
/* styles Not a pure module */